import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { IntegratedIReckonRoom } from '@era/locations-sdk';

export type IntegratedIReckonRoomState = EntityState<IntegratedIReckonRoom>;

export function selectIReckonIntegrationIdFromIntegration(room: IntegratedIReckonRoom): string {
  return room.roomUniqueId;
}

export const adapter: EntityAdapter<IntegratedIReckonRoom> = createEntityAdapter<IntegratedIReckonRoom>({
  selectId: selectIReckonIntegrationIdFromIntegration,
});

export const initialState: IntegratedIReckonRoomState = adapter.getInitialState();
